export default __webpack_public_path__ + "static/media/dancer_4.1781a958.png";